import jwtDecode from 'jwt-decode';
import { FeatureHub, FeatureHubConfig, ClientContext } from 'featurehub-javascript-client-sdk';
import { isProd } from '../environment';

export const setFeatureHubConfig = (cfg: FeatureHubConfig | undefined, ctx?: ClientContext) => {
  if (cfg) {
    FeatureHub.set(cfg, ctx || cfg.newContext());
  }

  return cfg;
};

export const getFeatureHubConfig = (): FeatureHubConfig | undefined => FeatureHub.config;

export const getFlagValue = (key: string): boolean => FeatureHub.context.getFlag(key) || false;

// See git history to enable user segmenting
export const getLDUserFromJwt = (auth: string): string => {
  try {
    if (auth) {
      const jwt: any = jwtDecode(auth) || {};

      return jwt?.user?.id || 'anonymous';
    }
  } catch (e: any) {
    if (!isProd()) {
      console.warn('jwt is not valid', auth);
      console.error(e, { auth });
    }
  }

  return '';
};
